import { Box, Checkbox, Stack, Text } from '@chakra-ui/core';
import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortTypes } from '../filters/seekersFiltersContextValueType';
import { SearchAndSortProps } from './searchAndSortType';

export enum HireDetailsStatus {
  REQUESTED = 'requested', // recruiter has requested the candidate to fill up the hire form.
  IN_PROGRESS = 'inProgress', // candidate has started to fill up the hire form.
  HELP_REQUESTED = 'helpRequested', // candidate has requested help in filling up the form.
  COMPLETED = 'completed', // candidate has finished filling up the hire form.
  NEEDS_ACTION = 'needsAction', // recruiter has requested the candidate to update the hire form data.
}
export const HireStatus = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchAndSortProps): JSX.Element => {
  const { t } = useTranslation('hireDetail');

  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleHireStatus = (searchAndSort: SearchAndSortTypes) => {
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes({ ...searchAndSort });
  };

  return (
    <Box>
      <Stack direction="column">
        {Object.values(HireDetailsStatus).map((value) => (
          <Checkbox
            data-testid={`hireStatus_${value}`}
            key={value}
            isChecked={tempSearchAndSortType.hireStatus.includes(value)}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              const updated = [...tempSearchAndSortType.hireStatus];
              /* istanbul ignore next */
              if (e.target.checked) {
                if (!updated.includes(value)) updated.push(value);
              } else {
                const idx = updated.indexOf(value);
                if (idx > -1) updated.splice(idx, 1);
              }
              onHandleHireStatus({ ...tempSearchAndSortType, hireStatus: updated });
            }}
          >
            <Text px={3} fontSize="14px">
              {t(`status.${value}`)}
            </Text>
          </Checkbox>
        ))}
      </Stack>
    </Box>
  );
};
